// extracted by mini-css-extract-plugin
export default {"member":"memberAssigned_member__EwSu4","total":"memberAssigned_total__7aQZl"};